import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lib-ui-empty-table-placeholder',
  templateUrl: './empty-table-placeholder.component.html',
  styleUrls: ['./empty-table-placeholder.component.css'],
  standalone: false
})
export class EmptyTablePlaceholderComponent {
  @Input()
  hasError = false;

  @Input()
  noData = true;

  @Input()
  showRetry = false;

  @Input()
  loading = false;

  @Input()
  message = '';

  @Output()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  retry = new EventEmitter<any>();

  handleRetry() {
    this.retry.emit();
  }
}
